<template>
    <div class="maintainer-list relative">
        <div class="buttons" :style="{position: button_position}">
<!--            <el-button @click="reset">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button type="primary" @click="exportExcel">导出报表</el-button>
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="7" :lg="4" :xl="5" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属专家搜索：</span>
                <el-input v-model="search_data" placeholder="姓名或手机号码模糊搜索"></el-input>
            </el-col>
            <el-col :md="7" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">结算时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="monthrange"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份"
                    format="yyyy 年 MM 月"
                    value-format="yyyy-MM-dd"
                    @change="monthChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="7" :lg="4" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    class="status" v-model="status" placeholder="请选择状态" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="7" :lg="4" :xl="6" :sm="12" :xs="24">
                <el-button @click="reset">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <p style="float: left;">{{ month }} 服务费总金额（元）：￥{{allAmount}}&ensp;&ensp;&ensp;&ensp;<el-button type="danger" size="mini" @click="salaryRules">结算规则</el-button></p>
        <el-table :data="tableData" border style="width: 100%" :span-method="arraySpanMethod">
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="doctor_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="user_number" label="服务对象人数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="90" prop="user_name" label="服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="month_txt" label="服务周期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="90" prop="times_txt" label="服务期数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="70px" prop="meet_number" label="会面数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="70px" prop="reply_number" label="回复数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120px" prop="health_record_number" label="新增健康档案数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="90" prop="statement_date" label="结算日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="90" prop="pay_date" label="付款日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="before_pay" label="税前报酬" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="tax" label="预缴个税" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="amount" label="应付报酬" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="status_txt" fixed="right" label="状态" align="center" label-class-name="label" v-slot="scope">
                <el-button  type="primary" size="mini" v-if="scope.row.is_pay == 1">已付款</el-button>
                <el-button @click="paySalary(scope.row)"  type="warning" size="mini" v-if="scope.row.is_pay == 2">待办</el-button>
                <el-button type="info" size="mini" v-if="scope.row.is_pay == 3">结算中</el-button>
                <el-button type="danger" size="mini" v-if="scope.row.is_pay == 4">结算超时</el-button>
            </el-table-column>
            <el-table-column width="85" fixed="right" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button  @click="goDetail(scope.row)" type="text" size="mini">详情</el-button>
                <el-button  @click="paySalary(scope.row)" type="text" size="mini" v-if="scope.row.is_pay != 1">付款</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5, 10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite" :sm="6" :xs="6"
        ></el-pagination>

        <el-dialog :title="preview_title" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
        <el-dialog class="pay_data" :title="pay_title" :visible.sync="payVisible">
            <el-form label-position="right" :model="payForm" ref="payForm"
                     style="width: 100%;margin: 0px auto 0 auto;"
                     class="form" autocomplete="off">
                <div style="text-align: left;margin-bottom: 10px;">
                    <el-button @click="addPay">添加付款</el-button>
                    <el-button @click="addPay" style="border: none;color: #ff0000;">应付报酬：{{dialog_amount}}</el-button>
                </div>
                <div v-for="(pay_data, index) in payForm.pay_data">
                    <div style="float: left;width: 36%;margin-bottom: 5px;">
                        <el-tooltip class="item" effect="dark" content="付款金额" placement="top">
                        <el-input type="number" min="100" v-model="pay_data.amount" :disabled="pay_data.is_disable" placeholder="请输入付款金额" autocomplete="off"
                                  style="width: 100%;"></el-input>
                        </el-tooltip>
                    </div>
                    <div style="float: left;margin-left: 1%;width: 35%;margin-bottom: 5px;">
                        <el-tooltip class="item" effect="dark" content="付款日期" placement="top">
                        <el-date-picker v-model="pay_data.pay_date" :disabled="pay_data.is_disable" type="date" placeholder="付款日期" format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                        </el-tooltip>
                    </div>
<!--                    <div style="float: left;width: 35%;margin-left: 1%;margin-bottom: 5px;">-->
<!--                        <el-date-picker v-model="pay_data.account_date" :disabled="pay_data.is_disable" type="date" placeholder="到账日期" format="yyyy-MM-dd"-->
<!--                                        value-format="yyyy-MM-dd">-->
<!--                        </el-date-picker>-->
<!--                    </div>-->
                    <div style="float: left;width: 18%;margin-left: 1%;margin-bottom: 5px;">
                        <el-select v-model="pay_data.is_pay" :disabled="pay_data.is_disable" placeholder="是否已付款">
                            <el-option v-for="item in allPayStatus" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="delete_icon" style="float: left;margin-left: 1%;width:8%;margin-bottom: 5px;" v-if="payForm.pay_data.length > 1 && !pay_data.id">
                        <el-button type="danger" icon="el-icon-delete" circle @click="delItem(index)"></el-button>
                    </div>
                </div>


            </el-form>
            <div slot="footer" class="dialog-footer" style="clear: both;">
                <el-button @click="payVisible = false">取 消</el-button>
                <el-button type="primary" @click="paySubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="服务费结算规则"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <p>服务费结算规则：
                以服务对象签约日期起计，满31天为一个服务周期，满一个服务周期后第15日起开始结算服务费，并在15日内支付完毕。</p>
            <p>
                举例：假设2024年7月1日服务对象A签约了专家B，到2024年7月31日满一个周期，2024年8月15日平台开始给专家B结算7月1日-7月31日这一周期服务对象A的服务费，并在2024年8月29日24点前支付完毕，以此类推。
            </p>
        </el-dialog>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import env from "@/api/env";
    import {export2Excel} from "@/utils/excel";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                rowObj: [3, 3],
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allAmount: 0,
                month: '',
                allStatus: [
                    {
                        id: '1',
                        name: '已付款'
                    },
                    {
                        id: '2',
                        name: '待办'
                    },
                    {
                        id: '3',
                        name: '结算中'
                    },
                    {
                        id: '4',
                        name: '结算超时'
                    },
                ],
                allPayStatus: [
                    {
                        id: '1',
                        name: '已付款'
                    },
                    {
                        id: '2',
                        name: '未付款'
                    },
                ],
                status: '',
                //搜索栏
                account: '',
                user_name: '',
                user_role: '3',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                search_data: '',
                is_submit: false,
                dialogImgFormVisible: false,
                payVisible: false, // 付款设置
                dialog_amount: 0.00,// 应付报酬
                pay_title:'',
                preview_title: '',
                imageUrl: [],
                imgPREFIX: env.IMG_COMMON_URL_PREFIX,
                payForm: {
                    id: '',
                    pay_data: [
                        {
                            id: '',
                            pay_date: '',
                            account_date: '',
                            is_pay: '1',
                            amount: '1000',
                            is_disable: false,
                        }
                    ],
                }, // 付款设置数据
                button_position: 'absolute',
                centerDialogVisible: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
        },
        mounted() {

            //获取日志列表
            this.getList();
        },
        methods: {
            monthChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            getExpiredDate(type) {
                let baseDate = ''

                if(type == 2) {
                    baseDate = this.ruleForm.old_expired_date
                } else {
                    if (!this.ruleForm.start_date) return
                    baseDate = this.ruleForm.start_date
                }

                let date = new Date(baseDate)
                let y = date.getFullYear() + this.ruleForm.year;
                let m = date.getMonth() + 1;
                let d = date.getDate()
                this.ruleForm.expired_date = `${y}-${m}-${d}`

                if (this.ruleForm.year > 0 && this.ruleForm.start_date) {
                    // 计算服务费
                    this.ruleForm.amount = (this.ruleForm.year * this.service_fee).toFixed(2)
                }
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                // row.no:第 no 行数据
                // row.data_num 需要合并中的几条数据中的 data_num 条：第1条需要合并

                // columnIndex 可能需要合并的数据列： 1、2、12、13、14
                if (columnIndex <= 2 || (columnIndex >= 11 && columnIndex <= 13 )) {
                    // if (rowIndex % 5 === 0) {
                    if (row.data_num == 1) {
                        return {
                            rowspan: row.user_number,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            timeToDate(time) {
                let dateTime = new Date(time);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let day = dateTime.getDate();
                return `${year}-${month}-${day}`
            },
            userRoleChange(){
                this.is_submit = true;
                this.page = 1;
                this.search_data = '';
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
            //获取日志列表
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'getSalaryList',
                    params: {
                        user_role: this.user_role,
                        search_data: this.search_data,
                        start_month: this.start_date,
                        end_month: this.end_date,
                        status: this.status,
                    },
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                console.log(params)
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let list = res.data.data.list.list
                    let len = list.length
                    let n = 0;
                    for (var i = 0; i < len; i++) {
                        if (list[i].data_num == 1) {
                            // 序号
                            list[i].no = (this.page - 1) * this.perpage + n + 1
                            n++;
                        }

                        switch (list[i].statement_type) {
                            case '1':
                                list[i].statement_type_txt = '银行卡转账';
                                break;
                        }
                    }

                    this.tableData = list;
                    this.total = res.data.data.page.count;
                    this.allAmount = res.data.data.list.all_amount;
                    this.month = res.data.data.list.month;
                    this.is_submit = false;
                    if (res.data.data.list.start_date && res.data.data.list.end_date) {
                        this.search_expired_date = [res.data.data.list.start_date, res.data.data.list.end_date]
                    }

                    localStorage.setItem('user_salary_user_role', this.user_role)
                    localStorage.setItem('user_salary_start_date', this.timeToDate(res.data.data.list.start_date))
                    localStorage.setItem('user_salary_end_date', this.timeToDate(res.data.data.list.end_date))

                    localStorage.setItem('prev_page', 'user_salary')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            //搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            goDetail(data) {
                this.$router.push({
                    name: "userSalaryDetail", params: {
                        user_id: data.user_id,
                        user_role: data.user_role,
                        month: data.statement_month,
                    }
                });
            },
            // 打开付款设置
            paySalary(data) {
                // 设置付款
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'getPaySalary',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    let list = res.data.data
                    this.payForm.pay_data = [];
                    if (list) {
                        let is_disable = false;
                        for (let i = 0; i < list.length; i++) {
                            is_disable = false;
                            if (list[i].is_pay == 1) {
                                is_disable = true;
                            }
                            this.payForm.pay_data.push({
                                pay_date: list[i].pay_date,
                                account_date: list[i].account_date,
                                is_pay: list[i].is_pay.toString(),
                                amount: list[i].amount,
                                id: list[i].id,
                                is_disable: is_disable,
                            })
                        }
                    } else {
                        this.payForm.pay_data.push({
                            pay_date: (new Date()),
                            account_date: (new Date()),
                            is_pay: '1',
                            amount: '1000',
                        })
                    }
                    this.pay_title = `服务费支付：${data.doctor_name}-${data.user_name}（${data.month_txt}）`
                    this.dialog_amount = data.user_salary
                    this.payVisible = true;
                    this.payForm.id = data.id
                }).catch(()=>{
                });
            },
            // 添加付款
            addPay() {
                this.payForm.pay_data.push({
                    pay_date: (new Date()),
                    account_date: (new Date()),
                    is_pay: '1',
                    amount: '100',
                })
            },
            // 提交付款设置
            paySubmit() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                // 设置付款
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'setPaySalary',
                    params: {
                        id: this.payForm.id,
                        pay_data: this.payForm.pay_data
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '操作成功',
                        duration: 1500
                    });
                    this.payVisible = false;
                    this.getList();
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });

            },
            delItem(index) {
                if (this.payForm.pay_data.length > 1) {
                    this.payForm.pay_data.splice(index, 1)
                }
            },
            reset() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }

                this.is_submit = true;
                this.user_role = '3';
                this.page = 1;
                this.search_data = '';
                this.status = '';
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
            // 预览
            async previewImage(img, index, title){
                if (this.$refs.image_box) {
                    this.$refs.image_box.setActiveItem(index)
                }
                this.imageUrl = [];

                this.imageUrl.push(this.imgPREFIX + img);

                this.preview_title = title + '的银行卡照片'
                this.active_index = index
                this.dialogImgFormVisible = true;

            },
            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'exportDoctorSalaryList',
                    params: {
                        search_data: this.search_data,
                        start_month: this.start_date,
                        end_month: this.end_date,
                    },
                };

                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    window.location.href = env.IMG_URL_PREFIX + res.data.data.file_url

                });
            },
            changeDate(d) {
                let time = new Date(d);
                let y = time.getFullYear();
                let m = time.getMonth() + 1;
                return `${y}年${m}月`
            },
            salaryRules() {
                this.centerDialogVisible = true
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .el-icon-picture-outline,.ad-coentent{color: #6B99F0;cursor: pointer;}
    .pay_data {
        .el-dialog {
            min-width: 560px !important;
            width: 560px !important;
        }
        .delete_icon {
            .el-icon-delete{
                transform: translateY(-4px);
            }
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>

